import { cn } from "@/lib/utils";
import { Loader2Icon } from "lucide-react";
import type { ComponentProps } from "react";
import Shimmer from "./shimmer/shimmer";

export default function Spinner({
  className,
  ...props
}: ComponentProps<"svg">) {
  return (
    <Loader2Icon
      role="status"
      className={cn("animate-spin", className)}
      aria-label="Loading"
      {...props}
    />
  );
}

export function FullPageSpinner({
  className,
  ...props
}: ComponentProps<"div">) {
  return (
    <div
      role="status"
      className={cn(
        "flex h-full w-full grow items-center justify-center",
        className,
      )}
      aria-label="Loading"
      {...props}
    >
      <Shimmer
        spread={3}
        weight="semibold"
        className="font-display text-[1.3125rem] leading-none tracking-wide md:text-[1.5rem]"
      >
        SoulByte
      </Shimmer>
    </div>
  );
}
